import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import styles from './styles.scss';

/*
  Video - Wrapper for ReactPlayer if being used with the ImageGallery

  Notes:
  If the option for auto-playing videos is needed in the future, then
  this component needs to be moderately modified. The problem is that Slick
  will create clones of each slide, and using a simple implementation of
  setState will cause all the videos to play when in view.
*/
const Video = ({ source, itemIndex, slideIndex }) => {
  const [playing, setPlaying] = useState(false);

  const setTrue = useCallback(() => setPlaying(true), []);
  const setFalse = useCallback(() => setPlaying(false), []);

  useEffect(() => {
    // Pause video after slide is swiped away
    if (itemIndex !== slideIndex) {
      setFalse();
    }
  }, [slideIndex]);

  return (
    <ReactPlayer
      url={source}
      controls
      config={{
        file: {
          attributes: {
            controlsList: 'nodownload noremoteplayback',
            disablePictureInPicture: true,
          },
        },
      }}
      playing={playing}
      onPlay={setTrue}
      onStart={setTrue}
      onPause={setFalse}
      onEnded={setFalse}
      className={styles.reactPlayer}
      height="100%"
      width="100%"
    />
  );
};

Video.propTypes = {
  source: PropTypes.string,
  itemIndex: PropTypes.number,
  slideIndex: PropTypes.number,
};

const Slide = ({ item, itemIndex, slideIndex }) => {
  const { type, source } = item;

  return type === 'image' ? (
    <div className={styles.slideWrapper}>
      <img src={source} className={styles.fullImage} />
    </div>
  ) : (
    <div className={styles.slideWrapper}>
      <Video source={source} itemIndex={itemIndex} slideIndex={slideIndex} />
    </div>
  );
};

Slide.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.oneOf(['image', 'video']),
    source: PropTypes.string,
  }),
  itemIndex: PropTypes.number,
  slideIndex: PropTypes.number,
};

export default Slide;
